import Vue from "vue";
import axios from "axios";
import VueRouter, { NavigationFailureType } from "vue-router";
import { Service } from "typedi";
import { HttpInterceptor } from "~shared/classes/http-interceptor";
import { AbortResponseError } from "~shared/errors/abort-response.error";

@Service()
export class DefaultErrorInterceptor extends HttpInterceptor {
  public onResponseError(error: Error): void | Promise<void> {
    if (error instanceof AbortResponseError) {
      throw error;
    }

    if (
      VueRouter.isNavigationFailure(error, NavigationFailureType.cancelled) ||
      VueRouter.isNavigationFailure(error, NavigationFailureType.aborted)
    ) {
      throw new AbortResponseError();
    }

    let { message } = error;

    if (axios.isAxiosError(error)) {
      message = (error.response?.data as { message: string })?.message;
    }

    if (message) {
      Vue.notify({
        type: "error",
        text: message,
        duration: 2000,
      });
    }

    throw new Error(message);
  }
}
